import { EventEmitter, Injectable } from "@angular/core";

import { DepartmentFilterType } from "../models/DepartmentFilterType";
import { ViewType } from "../models/Enums";
import { ToolFilter } from "../models/ToolFilter";
import { CompanyService } from "./company.service";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class ToolFilterService {
  toolFilterChange: EventEmitter<ToolFilter> = new EventEmitter<ToolFilter>();
  // TODO: Remove logic for tempToolFilterChange
  // TODO: Let SideFilter fetch aggregations on it's own (not getting it from tools.component) when backend is ready for changes
  /** Emits filter change which is not applied to data grid, it's just to get correct aggregations */
  tempToolFilterChange: EventEmitter<ToolFilter> = new EventEmitter<ToolFilter>();

  constructor(
    public companyService: CompanyService,
    private storageService: StorageService,
  ) {}

  create(preserve?: Partial<Pick<ToolFilter, "asc" | "sort" | "take" | "skip">>): ToolFilter {
    const filter = new ToolFilter(this.companyService.selectedCompany.name);
    this.setDepartmentFilter(filter);
    if (preserve) {
      filter.asc = preserve.asc;
      filter.sort = preserve.sort;
      filter.take = preserve.take;
      filter.skip = preserve.skip;
    }
    return filter;
  }

  get(viewType: ViewType): ToolFilter {
    const filterState = this.storageService.getToolFilter(viewType) ?? new ToolFilter();

    filterState.companyId = this.companyService.selectedCompany.name;
    this.setDepartmentFilter(filterState);
    filterState.gridViewType = viewType;

    return filterState;
  }

  private setDepartmentFilter(filter: ToolFilter) {
    const selectedDepartment = this.companyService.selectedCompany.department;
    if (!selectedDepartment) return;
    switch (selectedDepartment.departmentFilterType) {
      case DepartmentFilterType.AllDepartments:
        filter.department = undefined;
        filter.filterOnlyNoDepartment = false;
        break;
      case DepartmentFilterType.NoDepartment:
        filter.department = undefined;
        filter.filterOnlyNoDepartment = true;
        break;
      case DepartmentFilterType.Department:
        filter.department = selectedDepartment?.name;
        filter.filterOnlyNoDepartment = false;
        break;
      default:
        throw new Error("Unknown department type");
    }
  }

  set(filter: ToolFilter, emitChange = true) {
    this.storageService.setToolFilter(filter.gridViewType, filter);

    if (!emitChange) return;
    this.toolFilterChange.emit(this.get(filter.gridViewType));
  }

  /**
   * Set filter to get aggregations,
   * but don't persist it until user applies it
   * @param filter
   */
  tempSet(filter: ToolFilter) {
    this.tempToolFilterChange.emit(filter);
  }

  resetFilters(viewType: ViewType) {
    const { asc, sort, take, skip } = this.get(viewType);
    const filter = this.create({ asc, sort, take, skip });
    filter.gridViewType = viewType;
    this.set(filter);
  }
}
